/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsExtraInvoiceDetailsEnabledQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type IsExtraInvoiceDetailsEnabledQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isExtraInvoiceDetailsEnabled: boolean } | null };


export const IsExtraInvoiceDetailsEnabledDocument = gql`
    query IsExtraInvoiceDetailsEnabled($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isExtraInvoiceDetailsEnabled
  }
}
    `;

/**
 * __useIsExtraInvoiceDetailsEnabledQuery__
 *
 * To run a query within a React component, call `useIsExtraInvoiceDetailsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExtraInvoiceDetailsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExtraInvoiceDetailsEnabledQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useIsExtraInvoiceDetailsEnabledQuery(baseOptions: Apollo.QueryHookOptions<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables> & ({ variables: IsExtraInvoiceDetailsEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>(IsExtraInvoiceDetailsEnabledDocument, options);
      }
export function useIsExtraInvoiceDetailsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>(IsExtraInvoiceDetailsEnabledDocument, options);
        }
export function useIsExtraInvoiceDetailsEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>(IsExtraInvoiceDetailsEnabledDocument, options);
        }
export type IsExtraInvoiceDetailsEnabledQueryHookResult = ReturnType<typeof useIsExtraInvoiceDetailsEnabledQuery>;
export type IsExtraInvoiceDetailsEnabledLazyQueryHookResult = ReturnType<typeof useIsExtraInvoiceDetailsEnabledLazyQuery>;
export type IsExtraInvoiceDetailsEnabledSuspenseQueryHookResult = ReturnType<typeof useIsExtraInvoiceDetailsEnabledSuspenseQuery>;
export type IsExtraInvoiceDetailsEnabledQueryResult = Apollo.QueryResult<IsExtraInvoiceDetailsEnabledQuery, IsExtraInvoiceDetailsEnabledQueryVariables>;